export default {
    computed: {
        isGoal() {
            return this.post.artifact_type == 'goal'
        },
        isUser() {
            return this.post.artifact_type == 'user'
        },
        isOKRCheckin() {
            return this.post.artifact_type == 'checkin'
        },
        isKeyResult() {
            return this.post.artifact_type == 'key_result'
        },
        isObjective() {
            return this.post.artifact_type == 'objective'
        },
        isNetwork() {
            return this.post.artifact_type == 'network'
        },
        isValue() {
            return this.post.artifact_type == 'value'
        },
        isArtifactDeleted() {
            return this.post.artifact.deleted_at
        },
        isPDI() {
            return this.post.artifact_type == 'action_plan' || this.post.artifact_type == 'pda_checkin'
        },
    },
}
